import { Item, RnbCalculatorPayload } from 'typings'
import { removeTrailingId } from 'ui'
import { Gift, GIFT_APPLICATION } from '../../../typings'

export function mapGiftItems(
  skusGift: RnbCalculatorPayload['skusGift']
): Item[] {
  if (!skusGift) {
    return []
  }

  const { gifts } = skusGift

  const validItems = gifts?.filter((gift) => gift.id && gift.name)
  if (!validItems) {
    return []
  }

  return validItems.map((gift) => ({
    id: gift.id as string,
    name: removeTrailingId(gift.name as string),
  }))
}

export function mapGift<T>(data: RnbCalculatorPayload, type: T): Gift<T> {
  const { skusGift, activateGiftsMultiplier } = data

  return {
    type,
    items: mapGiftItems(skusGift),
    application: activateGiftsMultiplier
      ? GIFT_APPLICATION.PER_ITEM
      : GIFT_APPLICATION.PER_CART,
    maxQuantity: skusGift.quantitySelectable,
  }
}
